import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 13v-8","key":"svg-0"}],["path",{"d":"M4 13h16","key":"svg-1"}],["path",{"d":"M7 16h10","key":"svg-2"}],["path",{"d":"M10 19h4","key":"svg-3"}]]

const IconCircuitGround = createReactComponent('outline', 'circuit-ground', 'CircuitGround', __iconNode);

export default IconCircuitGround;